module.exports = __webpack_public_path__ + "img/repair.92ee1eff.png";